"use client";

import { Provider } from "jotai/react";
import { SessionProvider } from "@/app/_lib/auth/session-provider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <Provider>{children}</Provider>
    </SessionProvider>
  );
}
